import { render } from "./AverageStats.vue?vue&type=template&id=0d5337d7"
import script from "./js/averageStats.js?vue&type=script&lang=js&external"
export * from "./js/averageStats.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__